// --------------------------------------
// PhoneInputWithCountry.jsx  (المُعدّل)
// --------------------------------------

import React, { useEffect, useState, useRef } from "react";
import { Menu } from "@headlessui/react";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import useLanguageDirection from "../../hooks/useLanguageDirection";
import { AddPhoneNumber } from "../../redux/reducer/userAddressReducer";
import { useLanguageNavigate } from "../../hooks/useLanguageNavigation";
import LoadingSpinner from "../animation/LoadingSpinner";

const PhoneInputWithCountry = ({ defaultCountryName, placeholder, token }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const [countries, setCountries] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [search, setSearch] = useState("");
  const [phone, setPhone] = useState("");
  const [loading, setLoading] = useState(false);

  const searchRef = useRef(null);
  const direction = useLanguageDirection();
  const navigateWithLang = useLanguageNavigate();
  // console.log(token);

  useEffect(() => {
    const load = async () => {
      try {
        const res = await fetch("/countriesAPI.json");
        const data = await res.json();
        setCountries(data);

        if (defaultCountryName) {
          const found = data.find(
            (c) =>
              c.name?.common?.toLowerCase() ===
              defaultCountryName?.toLowerCase()
          );
          if (found) setSelectedCountry(found);
        }
      } catch (err) {
        console.error("Failed to load countries:", err);
      }
    };
    load();
  }, [defaultCountryName]);

  const getCountryCodeString = (c) => {
    if (!c?.idd) return "";
    const root = c.idd.root || "";
    const suffix = c.idd.suffixes?.[0] || "";
    return `${root}${suffix}`.replace("++", "+");
  };

  const isPhoneValid = (p) => {
    const digits = p.replace(/[^\d]/g, "");
    return digits.length >= 4;
  };

  // ------------------------
  //   HANDLE SUBMIT
  // ------------------------
  const handleSubmit = () => {
    // console.log(token);
    localStorage.setItem("accessToken", token);
    const payload = {
      countryCode: getCountryCodeString(selectedCountry),
      phone: phone.trim(),
    };

    setLoading(true);

    dispatch(AddPhoneNumber(payload))
      .unwrap()
      .then(() => {
        setTimeout(() => {
          setLoading(false);
          navigateWithLang("/my-account/dashboard");
        }, 3000);
      })
      .catch(() => {
        setTimeout(() => {
          setLoading(false);
          navigateWithLang("/my-account/dashboard");
        }, 3000);
      });
  };

  // if (loading) {
  //   return (
  //     <div className="flex items-center justify-center h-40">
  //       <LoadingSpinner />
  //     </div>
  //   );
  // }

  return (
    <div className="w-full max-w-md space-y-6">
      <div className="flex items-center bg-white rounded-sm">
        {/* Country Dropdown */}
        <Menu as="div" className="relative w-16">
          <Menu.Button
            onClick={() => setTimeout(() => searchRef.current?.focus(), 80)}
            className="flex items-center justify-between w-full px-2 py-2 bg-white rounded-sm hover:bg-gray-50"
          >
            {selectedCountry ? (
              <img
                src={selectedCountry.flags?.png || selectedCountry.flags?.svg}
                alt=""
                className="object-cover w-8 h-6 mx-auto "
              />
            ) : (
              <span className="text-gray-500">{t("choose")}</span>
            )}
            <span className="text-sm">▾</span>
          </Menu.Button>

          <Menu.Items className="absolute z-50 p-3 mt-2 overflow-y-auto bg-white rounded-sm w-72 max-h-[30vh]">
            <input
              ref={searchRef}
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              placeholder={t("SearchCountry")}
              className="w-full px-2 py-1 mb-3 rounded-sm focus:outline-none focus:ring-0"
            />

            {countries
              .filter((c) =>
                [
                  c.name.common.toLowerCase(),
                  c.translations?.ara?.common?.toLowerCase(),
                ].some((txt) => txt?.includes(search.toLowerCase()))
              )
              .map((c, i) => (
                <div
                  key={i}
                  onClick={() => {
                    setSelectedCountry(c);
                    setSearch("");
                  }}
                  className="flex items-center gap-3 p-2 rounded-sm cursor-pointer hover:bg-gray-100"
                >
                  <img
                    src={c?.flags?.png || c?.flags?.svg}
                    className="object-cover w-6 h-4"
                  />
                  <p className="text-sm">
                    {direction === "rtl"
                      ? c.translations?.ara?.common
                      : c.name.common}
                  </p>
                </div>
              ))}
          </Menu.Items>
        </Menu>

        {/* Phone Input */}
        <input
          type="text"
          value={phone}
          onChange={(e) => setPhone(e.target.value)}
          placeholder={placeholder}
          className="flex-1 px-3 py-3 rounded-sm focus:outline-none focus:ring-0"
        />
      </div>

      {/* Continue Button */}
      {loading ? (
        <div className="flex items-center justify-center h-10">
          <LoadingSpinner />
        </div>
      ) : (
        <button
          onClick={handleSubmit}
          disabled={!selectedCountry || !isPhoneValid(phone)}
          className={`block mx-auto px-4 py-2 text-black text-lg rounded-custom transition ${
            !selectedCountry || !isPhoneValid(phone)
              ? "bg-gray-400 cursor-not-allowed"
              : "bg-custom-yellow hover:scale-105"
          }`}
        >
          {t("continue")}
        </button>
      )}
    </div>
  );
};

export default PhoneInputWithCountry;
